import { MessageCircle } from "lucide-react";
import { SITE } from "../../lib/site";

export const FloatingWhatsApp = () => {
  return (
    <a
      href={SITE.whatsapp}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp-btn"
      aria-label="WhatsApp ile yazın"
      className="whatsapp-pulse fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 w-14 h-14 rounded-full bg-[#00844A] hover:bg-[#006F3E] text-white flex items-center justify-center shadow-xl transition-all duration-300 hover:scale-105"
    >
      <MessageCircle size={26} strokeWidth={2} />
    </a>
  );
};
